module.exports = __webpack_public_path__ + "static/media/image024.8e0652ee.jpg";